export default __webpack_public_path__ + "welcome-banner-promo-art-dark.d56e173d.svg";